export default "<svg>\n\t<path d=\"M7.5,3.8v3.8c5.6-0.1,10,1.2,12.5,7.4c-3.8-3.1-7.5-3.8-12.5-2.5v3.8L0,10L7.5,3.8z\"/>\n</svg>\n";